import { useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { client } from '../../hooks/Client'
import useSharedCollection from '../../firebase/useSharedCollection'
import useLocationFilter from '../../hooks/useLocationFilter'
import hasLocationFilter from '../../helpers/dashboardHelpers/hasLocationFilter'
import PersonasStatusVisualization from '../dataVisualizations/PersonasStatusVisualization'
import StaticCardLabel from './StaticCardLabel'
import DashboardCardOptions from './DashboardCardOptions'
import DashboardFilterBar from './DashboardFilterBar'
import DashboardLocationFilter from './DashboardLocationFilter'
import DashboardCardEmptyState from './DashboardCardEmptyState'
import { FILTER_EMPTY_STATE } from './dashboardEmptyStateConfig'
import { CATEGORICAL } from '../../helpers/chartPalette'
import countPersonasByStatus from '../../helpers/personas/countPersonasByStatus'
import usePersonaLocations from '../../hooks/usePersonaLocations'

// AI-CONTEXT: See docs/patterns.md#dashboard-static-card
// AI-CONTEXT: See docs/features/livereport-widgets-housevisits-personas.md
// Dashboard wrapper around the shared PersonasStatusVisualization. Owns
// the data hook + location filter + deep-link click handler.

const DashboardPersonaStatusCard = ({ item }) => {
    const history = useHistory()
    const personas = usePersonaLocations()
    const locations = useSharedCollection('Locations')
    const { filteredItems, selectedLocationId, setSelectedLocationId } =
        useLocationFilter(personas, { item })
    // Vaste paletkleur. Deze kaart staat alleen op het dashboard, dus er valt
    // niets te kiezen; de opgeslagen ColorOverrides blijven in Firestore staan
    // maar worden niet meer gelezen. Zie docs/patterns.md#ui-chart-palette.
    const barColor = CATEGORICAL[0]

    // Sleutels, volgorde, labels én de telling zelf uit de gedeelde helper —
    // de live-report-widget leest dezelfde. Tel hier niet zelf.
    const data = useMemo(
        () => countPersonasByStatus(filteredItems),
        [filteredItems]
    )

    const goToStatus = (payload) => {
        const statusId = payload?.statusId
        if (!statusId) return
        history.push(`/${client}/personas?status=${statusId}`)
    }

    const isLoading = personas === undefined
    const isEmpty = !isLoading && filteredItems.length === 0
    const isFilterEmpty = isEmpty && !!selectedLocationId

    return (
        <div className='housevisits-card-body'>
            <StaticCardLabel
                title='Status'
                pill={{ variant: 'personas', label: 'Medewerkers' }}
            />
            <DashboardFilterBar
                onClear={() => setSelectedLocationId('')}
                activeFilterCount={selectedLocationId ? 1 : 0}
                hasFilters={hasLocationFilter(locations)}
            >
                <DashboardLocationFilter
                    selectedLocationId={selectedLocationId}
                    onChange={setSelectedLocationId}
                />
            </DashboardFilterBar>
            <div className='housevisits-card-chart'>
                {isFilterEmpty ? (
                    <DashboardCardEmptyState
                        {...FILTER_EMPTY_STATE}
                        onCtaClick={() => setSelectedLocationId('')}
                    />
                ) : isEmpty ? (
                    <DashboardCardEmptyState type='personas-status' />
                ) : (
                    <PersonasStatusVisualization
                        data={data}
                        color={barColor}
                        height={'100%'}
                        onItemClick={goToStatus}
                    />
                )}
            </div>
            <DashboardCardOptions item={item} />
        </div>
    )
}

export default DashboardPersonaStatusCard
